(function () {
  'use strict';

  var menu = document.getElementById('mobile-menu');
  if (menu) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
    window.matchMedia('(min-width: 1001px)').addEventListener('change', function (event) {
      if (event.matches) menu.open = false;
    });
  }

  var VEST_RANGES = [
    { size: 'S', min: 3, max: 6 },
    { size: 'M', min: 6, max: 9 },
    { size: 'L', min: 9, max: 12 },
    { size: 'XL', min: 12, max: 17 },
    { size: '2XL', min: 17, max: 23 },
    { size: '3XL', min: 23, max: 31 },
    { size: '4XL', min: 31, max: 45 },
    { size: '5XL', min: 45, max: 65 }
  ];
  var EPSILON = 0.000001;
  var VEST_KG_LIMITS = [1.5, 3, 4, 5.5, 8, 10.5, 14, 20, 30];

  function positiveNumber(value) {
    if (typeof value === 'string' && value.trim() === '') return null;
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function recommendVest(value, unit) {
    var weight = positiveNumber(value);
    if (weight === null || (unit !== 'lb' && unit !== 'kg')) {
      return { ok: false, code: 'invalid-weight', message: 'Enter a weight greater than 0.' };
    }
    var pounds = unit === 'kg' ? weight * 2.2046226218 : weight;
    var sizes = VEST_RANGES.filter(function (range, index) {
      var min = unit === 'kg' ? VEST_KG_LIMITS[index] : range.min;
      var max = unit === 'kg' ? VEST_KG_LIMITS[index + 1] : range.max;
      return weight >= min - EPSILON && weight <= max + EPSILON;
    }).map(function (range) { return range.size; });
    if (!sizes.length) {
      return { ok: false, code: 'outside-chart', message: 'That weight is outside the chart: 3–65 lb (1.5–30 kg).' };
    }
    return { ok: true, sizes: sizes, pounds: pounds, boundary: sizes.length > 1 };
  }

  function purchaseData() {
    var node = document.getElementById('purchase-data');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  // The size helper can pick the suggested size on the vest page (the only page with #purchase-data).
  function selectionContext(kind, size) {
    var data = purchaseData();
    if (!data || data.kind !== kind) return null;
    var selector = document.getElementById('main-size');
    var colorSelector = document.getElementById('main-color');
    var variants = data.main;
    if (!selector || !Array.isArray(variants)) return null;
    var option = Array.from(selector.options).find(function (item) { return item.value === size; });
    var color = colorSelector ? colorSelector.value : '';
    var available = !!option && !option.disabled && variants.some(function (variant) {
      return variant.available && String(variant.size) === size && (!color || variant.color === color);
    });
    return { selector: selector, available: available, color: color };
  }

  function addText(result, className, value) {
    var paragraph = document.createElement('p');
    paragraph.className = className;
    paragraph.textContent = value;
    result.appendChild(paragraph);
  }

  function applySize(kind, size, button, result) {
    var context = selectionContext(kind, size);
    if (!context || !context.available) {
      button.disabled = true;
      button.textContent = 'Size ' + size + ' unavailable';
      addText(result, 'fit-result-note', 'That size is not available in the currently selected ' + kind + ' color. Choose another color and estimate again.');
      return false;
    }
    context.selector.value = size;
    context.selector.dispatchEvent(new Event('change', { bubbles: true }));
    button.textContent = 'Size ' + size + ' selected';
    addText(result, 'fit-result-note', 'Size ' + size + ' is now selected for your ' + kind + '.');
    return true;
  }

  function addUseButtons(result, kind, sizes) {
    var contexts = sizes.map(function (size) { return selectionContext(kind, size); });
    if (!contexts.some(function (context) { return context !== null; })) return;
    var actions = document.createElement('div');
    actions.className = 'fit-result-actions';
    sizes.forEach(function (size, index) {
      var context = contexts[index];
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'fit-use-size';
      button.textContent = context && context.available ? 'Use size ' + size : 'Size ' + size + ' unavailable';
      button.disabled = !context || !context.available;
      button.addEventListener('click', function () { applySize(kind, size, button, result); });
      actions.appendChild(button);
    });
    result.appendChild(actions);
    var unavailable = sizes.filter(function (size, index) { return contexts[index] && !contexts[index].available; });
    if (unavailable.length) {
      addText(result, 'fit-result-note', 'Unavailable sizes do not have an available variant in the currently selected ' + kind + ' color.');
    }
  }

  function showResult(kind, estimate) {
    var result = document.querySelector('[data-fit-result="' + kind + '"]');
    if (!result) return;
    result.replaceChildren();
    result.classList.toggle('is-error', !estimate.ok);
    result.hidden = false;
    if (!estimate.ok) {
      addText(result, 'fit-result-message', estimate.message);
      return;
    }
    addText(result, 'fit-result-message', 'Weight estimate: ' + estimate.sizes.join(' or ') + '.');
    if (estimate.boundary) addText(result, 'fit-result-note', 'This weight sits on a chart boundary, so compare both sizes with the full measuring guidance.');
    addUseButtons(result, kind, estimate.sizes);
  }

  // Breed data: measured pet-population weights, AKC breed-standard weights + coded reviews of this vest on the supplier listing
  // (built by research/redesign-2026-10-26/breed-fit/build_breeds.py). Owner evidence only when n >= 2.
  var BREEDS = [];
  try { BREEDS = JSON.parse((document.getElementById('breed-fit-data') || {}).textContent || '[]'); } catch (error) { BREEDS = []; }
  var breedList = document.getElementById('fit-breed-list');
  if (breedList) BREEDS.forEach(function (breed) { var option = document.createElement('option'); option.value = breed.name; breedList.appendChild(option); });
  var SHAPE_NOTES = {
    broad: 'Broad chest for their weight: size by the chest measurement, and if it lands between sizes, go up.',
    long: 'Long back for their height: check back length on the chart as well as chest.',
    deep: 'Deep, narrow chest: measure at the deepest point, just behind the front legs.'
  };

  function findBreed(value) {
    var query = String(value || '').trim().toLowerCase();
    if (!query) return null;
    var exact = BREEDS.find(function (breed) { return breed.name.toLowerCase() === query; });
    if (exact) return exact;
    var starts = BREEDS.filter(function (breed) { return breed.name.toLowerCase().indexOf(query) === 0; });
    return starts.length ? starts[0] : null;
  }

  function sizesForPounds(min, max) {
    var low = min === null ? VEST_RANGES[0].min : min;
    return VEST_RANGES.filter(function (range) { return range.max > low && range.min < max; }).map(function (range) { return range.size; });
  }

  function plural(name) { var m = name.match(/^(.*?)( \(.*\))?$/); return (/s$/.test(m[1]) ? m[1] : m[1] + 's') + (m[2] || ''); }

  function span(sizes) { return sizes.length > 1 ? sizes[0] + ' to ' + sizes[sizes.length - 1] : sizes[0]; }
  function sourceLink(parent, text, href) {
    var link = document.createElement('a');
    link.href = href; link.target = '_blank'; link.rel = 'noopener'; link.textContent = text;
    parent.appendChild(link);
  }

  // Population figures: measured adult pet dogs in UK vet records (breed-fit/population-stats/REPORT.md).
  // They place dogs on the chart's weight rows; they do not say a size fits, so the copy never says "wear".
  function addBreedNotes(result, breed, withSizes) {
    var label = breed.name.replace(/ \((miniature|standard|toy)\)$/, '');
    var pop = breed.pop;
    if (withSizes) {
      if (pop && pop.band) {
        addText(result, 'fit-result-message', 'Measured adult ' + plural(breed.name) + ': about ' + pop.band.in10 + ' in 10 fall in our ' + span(pop.band.sizes) + ' weight rows, most often ' + pop.band.mode + '.');
        var spread = 'The middle 80% weigh ' + pop.p10 + '–' + pop.p90 + ' lb.';
        if (pop.sex && pop.sex.female && pop.sex.male && span(pop.sex.female.sizes) !== span(pop.sex.male.sizes)) spread += ' Females are usually ' + span(pop.sex.female.sizes) + ', males ' + span(pop.sex.male.sizes) + '.';
        addText(result, 'fit-result-note', spread + ' Add their weight, then check chest and back to choose.');
      } else if (pop && pop.p10 && pop.over) {
        addText(result, 'fit-result-message', 'Measured adult ' + plural(breed.name) + ': more than ' + pop.over + ' in 10 weigh over 65 lb, the top of our 5XL.');
        addText(result, 'fit-result-note', 'The middle 80% weigh ' + pop.p10 + '–' + pop.p90 + ' lb. Measure chest and back before ordering; the vest may be too small.');
      } else if (pop && pop.median_only) {
        var mid = sizesForPounds(pop.median, pop.median + 0.01);
        addText(result, 'fit-result-message', 'The typical adult ' + label + ' in UK vet records weighs about ' + pop.median + ' lb, the ' + mid[0] + ' row on our chart.');
        addText(result, 'fit-result-note', 'We don’t have the spread for this breed, so add their weight and check chest and back.');
      } else {
        var sizes = sizesForPounds(breed.min, breed.max);
        addText(result, 'fit-result-message', 'Breed standard: ' + breed.akc + ', which is ' + span(sizes) + ' on our weight chart.');
        addText(result, 'fit-result-note', 'Standards describe show dogs, and pet dogs often weigh more. Add their weight, then check chest and back.');
      }
    }
    if (breed.shape && SHAPE_NOTES[breed.shape]) addText(result, 'fit-result-note', SHAPE_NOTES[breed.shape]);
    var owners = breed.owners;
    if (owners) {
      var parts = [];
      if (owners.fit.length) parts.push(owners.fit.length + ' said it fit (' + owners.fit.join(', ') + ')');
      if (owners.small) parts.push(owners.small + ' said it ran small');
      if (owners.big) parts.push(owners.big + ' said it ran large');
      var variety = /^Dachshund/.test(breed.name) ? ' (miniature or standard not stated)' : '';
      addText(result, 'fit-result-note', 'From ' + owners.n + ' reviews of this same vest on our supplier’s listing that mention a ' + label + variety + ': ' + parts.join(', ') + '. A small sample, so measure too.');
    }
    var source = document.createElement('p');
    source.className = 'fit-result-source';
    if (pop) {
      source.appendChild(document.createTextNode('Source: '));
      sourceLink(source, pop.src, pop.url);
      source.appendChild(document.createTextNode((pop.n ? ', ' + pop.n.toLocaleString('en-US') + ' dogs' : '') + '. Breed standard: '));
    } else {
      source.appendChild(document.createTextNode('Breed weight: '));
    }
    source.appendChild(document.createTextNode(breed.akc + ', '));
    sourceLink(source, 'AKC', breed.url);
    source.appendChild(document.createTextNode('.'));
    result.appendChild(source);
  }

  var vestForm = document.getElementById('vest-fit-helper');
  if (vestForm) {
    vestForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = document.getElementById('fit-vest-weight');
      var breedInput = document.getElementById('fit-vest-breed');
      var breedText = breedInput ? breedInput.value.trim() : '';
      var breed = findBreed(breedText);
      var hasWeight = input.value.trim() !== '';
      var result = document.querySelector('[data-fit-result="vest"]');
      input.setAttribute('aria-invalid', 'false');
      if (!hasWeight && !breedText) {
        showResult('vest', { ok: false, message: 'Enter their breed, their weight, or both.' });
        if (breedInput) breedInput.focus();
        return;
      }
      if (hasWeight) {
        var estimate = recommendVest(input.value, document.getElementById('fit-vest-unit').value);
        input.setAttribute('aria-invalid', String(estimate.code === 'invalid-weight'));
        showResult('vest', estimate);
        if (estimate.code === 'invalid-weight') { input.focus(); return; }
        if (breed) addBreedNotes(result, breed, false);
      } else if (breed) {
        result.replaceChildren();
        result.classList.remove('is-error');
        result.hidden = false;
        addBreedNotes(result, breed, true);
      }
      if (breedText && !breed) {
        if (!hasWeight) { result.replaceChildren(); result.classList.add('is-error'); result.hidden = false; }
        addText(result, hasWeight ? 'fit-result-note' : 'fit-result-message', 'We don’t have breed data for “' + breedText + '” yet. Their weight, chest and back still work.');
      }
    });
  }

  window.MitsiFitHelper = {
    recommendVest: recommendVest,
    applySize: function (kind, size) {
      var context = selectionContext(kind, String(size));
      if (!context || !context.available) return false;
      context.selector.value = String(size);
      context.selector.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
  };

  var dialog = document.getElementById('fit-dialog');
  if (!dialog) return;
  var opener;

  function selectTab(kind) {
    if (kind !== 'vest' && kind !== 'raincoat') kind = 'vest';
    ['vest', 'raincoat'].forEach(function (tabKind) {
      document.getElementById('fit-' + tabKind).hidden = tabKind !== kind;
      var button = document.getElementById('fit-tab-' + tabKind);
      button.setAttribute('aria-selected', String(tabKind === kind));
      button.tabIndex = tabKind === kind ? 0 : -1;
    });
  }

  document.querySelectorAll('[data-fit-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      opener = button;
      selectTab(button.dataset.fitOpen);
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('fit-open');
      document.getElementById('fit-close').focus();
    });
  });

  document.querySelectorAll('[data-fit-tab]').forEach(function (button) {
    button.addEventListener('click', function () { selectTab(button.dataset.fitTab); });
    button.addEventListener('keydown', function (event) {
      var kind;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp' || event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        kind = button.dataset.fitTab === 'vest' ? 'raincoat' : 'vest';
      } else if (event.key === 'Home') {
        kind = 'vest';
      } else if (event.key === 'End') {
        kind = 'raincoat';
      } else {
        return;
      }
      event.preventDefault();
      selectTab(kind);
      document.getElementById('fit-tab-' + kind).focus();
    });
  });

  ['fit-close', 'fit-done'].forEach(function (id) {
    document.getElementById(id).addEventListener('click', function () { dialog.close(); });
  });
  dialog.addEventListener('click', function (event) {
    var bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
  });
  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('fit-open');
    if (opener && opener.isConnected) opener.focus();
  });
})();

(function () {
  function visibleCount() {
    if (window.matchMedia('(max-width: 700px)').matches) return 1;
    if (window.matchMedia('(max-width: 1000px)').matches) return 2;
    return 3;
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-review-track]');
    if (!track) return;
    var section = root.closest('.mc-stories');
    var prevBtn = section && section.querySelector('[data-review-prev]');
    var nextBtn = section && section.querySelector('[data-review-next]');
    var pool = Array.prototype.slice.call(track.querySelectorAll('.mc-review-slide'));
    pool.forEach(function (node) { node.parentNode.removeChild(node); });
    var originals = [];
    var n = 0;
    var vis = 1;
    var index = 0;
    var locked = false;

    function cloneSlide(node) {
      var copy = node.cloneNode(true);
      copy.setAttribute('data-clone', 'true');
      return copy;
    }

    function build() {
      vis = visibleCount();
      while (track.firstChild) track.removeChild(track.firstChild);
      originals = pool.slice();
      n = originals.length;
      originals.forEach(function (slide) { track.appendChild(slide); });
      if (!n) return;
      var i;
      for (i = vis - 1; i >= 0; i -= 1) {
        track.insertBefore(cloneSlide(originals[(n - vis + i + n) % n]), track.firstChild);
      }
      for (i = 0; i < vis; i += 1) {
        track.appendChild(cloneSlide(originals[i % n]));
      }
      index = vis;
      jump(false);
    }

    function jump(animate) {
      if (animate) track.classList.add('is-ready');
      else track.classList.remove('is-ready');
      track.style.transform = 'translateX(' + (-index * (100 / vis)) + '%)';
    }

    function settle() {
      if (index >= n + vis) {
        index = vis;
        jump(false);
      } else if (index <= 0) {
        index = n;
        jump(false);
      }
      locked = false;
    }

    function go(delta) {
      if (locked || !n) return;
      locked = true;
      index += delta;
      jump(true);
      window.setTimeout(settle, 420);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (visibleCount() !== vis) build();
      }, 150);
    });

    build();
  }

  document.querySelectorAll('[data-review-carousel]').forEach(initCarousel);
})();
